import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'hadsup-video-layer',
    templateUrl: './video-layer.component.html',
    styleUrls: ['./video-layer.component.scss']
})
export class VideoLayerComponent implements OnInit {
    @Input() videoId: string = '';
    @Input() videoURL: string = '';
    @Output() closeLayer: EventEmitter<void> = new EventEmitter<void>();
    videoLink: SafeResourceUrl = '';

    constructor(
        private sanitizer: DomSanitizer,
    ) {
    }

    ngOnInit(): void {
        if (this.videoId)
            this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + this.videoId);
        else if (this.videoURL)
            this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoURL);
    }

    close() {
        this.closeLayer.emit();
    }
}
